{
  "common": {
    "survey": "Enkät",
    "cancel": "Ångra",
    "submit": "Skicka",
    "previewAndSave": "Förhandsgranska och spara",
    "save": "Spara",
    "saveError": "Fel vid sparandet",
    "add": "Lägg till",
    "remove": "Ta bort",
    "edit": "Redigera",
    "clear": "Töm",
    "preview": "Förhandsgranska",
    "search": "Sökning",
    "showAll": "Visa alla",
    "showLess": "Visa mindre",
    "continue": "Fortsätt",
    "next": "Följande",
    "previous": "Föregående",
    "verifyFormData": "Kontrollera uppgifterna",
    "toFrontPage": "Återvänd till ingångssidan",
    "name": "Namn",
    "firstName": "Förnamn",
    "lastName": "Efternamn",
    "username": "Användarnamn",
    "studentNumber": "Studentnummer",
    "degreeProgram": "Målgrupp",
    "email": "E-postadress",
    "value": "Värde",
    "type": "Typ",
    "isRequired": "Detta fält är obligatoriskt",
    "required": "Obligatoriskt",
    "yes": "Ja",
    "no": "Nej",
    "and": "och",
    "open": "Öppen",
    "closed": "Stängd",
    "closing": "Stänger",
    "pending": "Väntar",
    "back": "Tillbaka",
    "page": "Sida",
    "close": "Stäng",
    "modifiedAt": "Redigerad",
    "createdAt": "Skapad",
    "description": "Beskrivning",
    "dropdown": {
      "prompt": "Välj ett alternativ"
    },
    "status": "Status",
    "version": "Version",
    "select": "Välj",
    "question": "Fråga",
    "periods": {
      "spring": "Vår",
      "fall": "Höst"
    },
    "dateTime": "Datum och klockslag",
    "new": "Ny",
    "schema": "Enkätmall"
  },
  "surveyType": {
    "DEGREE_PROGRAM_SURVEY": "HowULearn-enkät",
    "COURSE_SURVEY": "HowUStudy-enkät",
    "HUP": "PhD-enkät",
    "HUT": "HowUTeach-enkät",
    "NOT_DEFINED": "Inte definerad"
  },
  "errorPage": {
    "errorHappened": "Fel i applikationen",
    "accessDeniedError": "Du har inte åtkomst till sidan eller funktionen du begär.",
    "unknownError": "Okänt fel",
    "notFound": "Sidan du sökte hittas inte"
  },
  "confirmButton": {
    "confirmCancel": "Ångra ändringarna?"
  },
  "languageSelector": {
    "fi": "Suomi",
    "en": "English",
    "sv": "Svenska"
  },
  "inLanguage": {
    "fi": "Finska",
    "en": "Engelska",
    "sv": "Svenska"
  },
  "login": {
    "chooseUser": "Välj användare",
    "chooseOrganization": "Välj organisation"
  },
  "organizations": {
    "UH": "Helsingfors universitet",
    "TEST": "Testorganisation",
    "AALTO": "Aalto-universitetet",
    "HAMK": "HAMK Yrkeshögskola",
    "METROPOLIA": "Yrkeshögskolan Metropolia",
    "FUNIDATA": "Funidata Testu Universitet",
    "ABO": "Åbo Akademi"
  },
  "userMenu": {
    "logOut": "Logga ut",
    "openLogoutMenu": "Öppna utloggningsmenyn",
    "closeLogoutMenu": "Stäng utloggningsmenyn",
    "changeLanguage": "Byt språk"
  },
  "surveyUserList": {
    "responseDate": "Svarsdatum"
  },
  "frontPage": {
    "intro": "UniHow är ett forskningsbaserat stödsystem för lärande och undervisning.",
    "yourSurveys": "Enkäter riktade till dig",
    "youHaveNoSurveys": "Det finns inga enkäter riktade till dig",
    "wantToStartASurvey": "Vill du starta en ny enkät?",
    "startSurveyInfo": "Förflytta dig för att granska och starta ny enkät",
    "startSurvey": "Starta ny enkät",
    "description": "<h3>UniHow fungerar på följande sätt</h3><p>Utifrån svaren producerar UniHow svarsrespons, som uppmuntrar respondenten att fundera till exempel på sina egna studie- eller undervisningsmetoder.</p><p>UniHow producerar lättlästa och begripliga rapporter om de grupper som svarat på enkäten. Rapporterna och materialet kan användas till exempel vid utvecklingen av undervisningen.</p><p>Data som samlas in via systemet kan enkelt överföras till statistiska program för analys och användas som forskningsdata.</p>",
    "whatIsUniHow": "Vad är UniHow?",
    "surveyBoxList": {
      "surveyTypes": {
        "DEGREE_PROGRAM_SURVEY": "HowULearn-enkäter",
        "COURSE_SURVEY": "HowUStudy-enkäter",
        "HUP": "PhD-enkäter",
        "HUT": "HowUTeach-enkäter"
      },
      "answerSurvey": "Svara på enkät",
      "viewFeedback": "Bekanta dig med responsen",
      "showMore": "Visa mer",
      "responseMessages": {
        "answered": "Du har svarat på enkäten",
        "notAnswered": "Du har inte svarat på enkäten",
        "waiting": "Väntar på ditt svar"
      },
      "endingMessages": {
        "ended": "Enkäten gick ut",
        "notEnded": "Enkäten går ut"
      },
      "feedbackMessages": {
        "notEnoughResponses": "Responsen kan inte visas eftersom det inte kom tillräckligt med svar på enkäten.",
        "notAnswered": "Responsen kan inte visas eftersom du inte har svarat på enkäten.",
        "shownAfterClosed": "Responsen visas om det finns tillräckligt med svar när enkäten avslutats.",
        "feedbackWaiting": "Responsen väntar dig",
        "feedbackViewed": "Du har bekantat dig med responsen",
        "hourglassAltText": "Timglas",
        "closeAltText": "Kors",
        "checkAltText": "Bockmarkering"
      }
    },
    "instructions": {
      "title": "Anvisningar för den som svarar på enkäten",
      "step1": {
        "title": "Svara på enkät",
        "description": "Öppna den öppna enkäten och svara på frågorna och påståendena utifrån dina egna studieerfarenheter."
      },
      "step2": {
        "title": "Vänta tills enkäten har stängts",
        "description": "Unihow beräknar resultaten och skapar din personliga respons när alla svar har samlats in och enkäten är stängd. Dina svar jämförs med andra som deltagit i enkäten."
      },
      "step3": {
        "title": "Bekanta dig med responsen",
        "description": "Du får ett e-postmeddelande med en länk till din egen feedback. Feedbacken innehåller experttips samt information om ditt sätt att arbeta jämfört med andra som deltagit i samma enkät."
      }
    }
  },
  "links": {
    "activityLog": "Aktivitetslogg",
    "myHowULearnSurveys": "Mina HowULearn-enkäter",
    "myHowUStudySurveys": "Mina HowUStudy-enkäter",
    "surveySchemas": "Enkätmallar",
    "permissions": "Användarbehörigheter",
    "surveyReports": "Samlingsrapporter om enkäter",
    "serviceReports": "Rapporter om användningen av tjänsten",
    "degreeProgramSurveys": "HowULearn-enkäter",
    "courseSurveys": "HowUStudy-enkäter",
    "teacherSurveys": "HowUTeach-enkäter",
    "studentInfo": "Information om studerande",
    "extraSurveyParts": "Tilläggsfrågor"
  },
  "linkGroupTitles": {
    "ownCourses": "Egna studiemoment",
    "howUTeach": "HowUTeach",
    "settings": "Inställningar",
    "reports": "Rapporter",
    "studentSurveys": "Studerandens enkäter",
    "surveys": "Enkäter"
  },
  "surveyLoadingError": "Fel vid sökning av enkäten",
  "surveyProgress": "Framstegen i enkäten",
  "requiredQuestionInfo": "frågor markerade med *-tecknet är obligatoriska",
  "responseMessage": {
    "responseSuccess": "Tack för ditt svar.",
    "responded": "Du har redan svarat på den här enkäten"
  },
  "survey": {
    "part": "Del",
    "researchConsent": "Mina svar får användas i forskningssyfte",
    "researchConsentTitle": "Lov för forskningssyfte",
    "responseSentTitle": "Enkäten har skickats",
    "responseSent": "Svaren har skickats",
    "close": "Stäng enkäten",
    "participants": "Deltagare",
    "scheduling": "Schemaläggningar",
    "remind": "Påminn",
    "responseSuccess": "Tack för ditt deltagande! Systemet kommer att ge dig respons utifrån dina svar. I responsen får du instruktioner för dina studier som bygger på dina svar. Du ser också dina svar i förhållande till andra studerandes svar. Du får ett e-postmeddelande när du kan läsa din respons i tjänsten UniHow.",
    "reopen": "Öppna enkäten på nytt",
    "export": {
      "title": "Exportera data",
      "excel": "Exportera data (Excel)",
      "sensitiveExcel": "Exportera data för forskningsändamål",
      "description": "Du exporterar enkätdata för forskningsändamål.",
      "enterReason": "Ge en detaljerad beskrivning av hur du avser använda uppgifterna (t.ex. forskningsproblemet och forskningsfrågorna).",
      "checkbox": "Jag bekräftar att jag endast använder de exporterade uppgifterna för de angivna forskningsändamålen."
    },
    "sensitiveInfoNotification": "Vänligen skriv inte hälsouppgifter eller annan känslig information i dina svar."
  },
  "surveyParticipantsEditor": {
    "NO_EMAIL": "E-postadress saknas",
    "DUPLICATE_EMAIL": "En annan svarande använder redan samma e-postadress",
    "NOT_FOUND": "Ingen studerande hittades.",
    "INVALID_EMAIL": "E-postadressen ser felaktig ut",
    "CHANGING_EMAIL": "En annan e-postadress har redan sparats för detta studentnummer. Bekräfta vilken adress som ska användas.",
    "ALREADY_IN_SURVEY": "Finns redan som enkätmottagare.",
    "surveyHasExistingParticipants": "tidigare tillagda deltagare.",
    "surveyHasExistingParticipant": "tidigare tillagd deltagare.",
    "addParticipantDescription": "Du kan lägga till eller kopiera en lista med studerande genom att separera studentnumren med kommatecken, blanksteg eller radbrytning.",
    "addParticipantPlaceholder": "Studiemomentets identifikation eller studentnummer",
    "courseRealisationIdHelp": "Du hittar studiemomentets identifikation i studieinformationssystemet, kontrollera din högskolas anvisningar om hur man lägger till deltagare i ett studiemoment.",
    "enterEmail": "Ange e-postadress",
    "selectEmail": "Välj e-postadress",
    "studentRegistry": "Studieinformationssystem",
    "loading": "Hämtar uppgifter...",
    "noSelectedCourses": "Inga valda studiemoment",
    "participantsSearchTitle": "Lägg till studerande med studentnummer eller studiemomentets identifikation.",
    "recipients": "Mottagare",
    "studentsAdded": "studerande tillagda.",
    "studentAdded": "studerande tillagd.",
    "studentsRejected": "studentnummer avvisades.",
    "studentRejected": "studentnummer avvisades.",
    "studentsAlreadyAdded": "studerande är redan med i enkäten.",
    "studentAlreadyAdded": "studerande är redan med i enkäten.",
    "requiresActionPl": "studerande kräver korrigering.",
    "requiresActionSg": "studerande kräver korrigering.",
    "participantsAlreadyAdded": "givna personer fanns redan bland mottagarna.",
    "participantAlreadyAdded": "given person finns redan bland mottagarna.",
    "missingCourseNames": "icke namngivna studiemoment har lagts till från studieinformationssystemet.",
    "missingCourseName": "icke namngivet studiemoment har lagts till från studieinformationssystemet.",
    "totalParticipants": "Deltagare sammanlagt ${ totalParticipantCount }",
    "missingEmails": "Deltagare utan en giltig e-post address får inte inbjudan till enkäten",
    "missingEppns": "Deltagare utan EPPN uteslöts från studiemomentet.",
    "teacherParticipantsEditor": {
      "searchLabel": "Lisää osallistujia sähköpostiosoitteiden avulla.",
      "placeholder": "Osallistujan sähköposti",
      "description": "Osallistujia voi lisätä useamman kerralla erottamalla sähköpostiosoitteet pilkulla, välilyonnillä tai rivinvaihdolla.",
      "participantAdded": "osallistuja lisätty.",
      "participantsAdded": "osallistujaa lisätty.",
      "participantRejected": "sähköpösti hylätty.",
      "participantsRejected": "sähköpöstia hylätty.",
      "recipients": "Sähköpostiosoitteiden kautta lisätyt osallistujat",
      "NOT_FOUND": "Henkilöä ei löytynyt."
    }
  },
  "addSurveyParticipants": {
    "title": "Redigera enkätens deltagare",
    "editParticipants": "Redigera deltagare",
    "saved": "Deltagarna sparades"
  },
  "editSurvey": {
    "title": "Redigera enkäten"
  },
  "startSurvey": {
    "schemaInfo": {
      "title": "Information om enkätmallen",
      "version": "Enkätmallens version"
    },
    "courseSurvey": {
      "startDate": "Enkätens starttidpunkt",
      "endDate": "Enkätens sluttidpunkt och sammandraget öppnas",
      "startDateHelp": "Om du ställer in starttidpunkten i förfluten tid startar enkäten genast.",
      "endDateHelp": "Sammandraget av enkäten är tillgänglig under denna period."
    },
    "startTitle": "Starta enkäten",
    "endTitle": "Avsluta enkäten",
    "startSurvey": "Starta en enkät",
    "selectSchema": "Välj typ",
    "content": "Innehåll",
    "noSelectedParticipants": "inga valda deltagare",
    "basicInfo": "Basuppgifter",
    "name": "Namn",
    "nameDescription": {
      "degreeProgramSurvey": "Du kan lägga till en preciserande del till enkätens namn, till exempel \"Grupp 1\".",
      "defaultSurvey": "Ge enkäten ett beskrivande namn. Namnet visas för deltagarna i den här formen."
    },
    "recipients": "Studerande",
    "courses": "Studiemoment",
    "introduction": "Inledande text",
    "introductionDescription": "Om du vill, kan du redigera enkätens inledande text som visas för deltagarna.",
    "completion": "Avslutande text",
    "conclusionDescription": "Om du vill, kan du redigera enkätens avslutande text som visas för deltagarna.",
    "messages": "Schemaläggning och meddelanden",
    "selectDegreeProgram": "Välj den grupp studerande till vilka du vill rikta enkäten",
    "degreeProgramNotSelected": "-",
    "degreeProgramDescription": "Välj i rullgardinsmenyn den grupp studerande till vilka du vill rikta enkäten",
    "email": {
      "invitationTitle": "Enkäten öppnas samt inbjudningsmeddelande",
      "invitationTitleDescription": "Inbjudningsmeddelandet skickas till studerandenas e-post när enkäten öppnas. Inbjudningsmeddelandet kan redigeras. Knappen Använd standardtext återställer den ursprungliga texten.",
      "endingTitle": "Enkäten stängs samt meddelande om att enkäten stängs",
      "endingTitleDescription": "Med meddelandet om att enkäten stängs informeras den studerande om att hens respons nu kan läsas. Meddelandet kan redigeras. Knappen Använd standardtext återställer den ursprungliga texten.",
      "setDefaultTitle": "Använd standardrubrik",
      "emailTitle": "Meddelandets rubrik",
      "setDefaultContent": "Infoga standardtext",
      "emailContent": "Meddelandets innehåll",
      "invitationEmailContentHelp": "Hjälptext för att skapa innehållet i inbjudningsmeddelandet",
      "endingEmailContentHelp": "Hjälptext för att skapa innehållet i det avslutande meddelandet"
    },
    "researchConsent": {
      "title": "Forskningstillstånd",
      "consentNotNeeded": "Forskningstillstånd behövs inte",
      "description": "(Använd detta endast om du har diskuterat saken med den instans på din högskola som är ansvarig för forskning)"
    },
    "participantsAndScheduling": "Deltagare",
    "scheduling": "Schemaläggning",
    "startDate": "Enkätens starttidpunkt",
    "startDateHelp": "Meddelandena om inbjudan till enkäten skickas vid denna tidpunkt. Om du ställer in starttidpunkten i förfluten tid startar enkäten genast.",
    "endDate": "Enkäten slutar och responsen öppnas",
    "endDateHelp": "Enkätresponsen öppnas vid denna tidpunkt.",
    "submitSuccess": "Enkäten har skapats",
    "submitSuccessLinkExplanation": "Direkt länk till enkäten (obs. Länken fungerar bara för dem som fått inbjudan till enkäten):",
    "viewQuestions": {
      "view": "Granska frågorna i enkäten",
      "title": "Frågorna i enkäten"
    },
    "surveyParts": {
      "title": "Enkätdelar",
      "introduction": "Frågeformuläret innehåller de nedan angivna enkätdelarna."
    },
    "extraSurveyPart": {
      "title": "Tilläggsfrågor",
      "introduction": "I slutet av enkäten kan du välja tilläggsfrågor som kan riktas till exempel för ett specifikt utbildningsprogram.",
      "add": "Välj tilläggsfrågor",
      "help": "Välj tilläggsfrågor som läggs till i enkäten. Frågorna och påståendena som lagts till visas för respondenterna i slutet av enkäten efter frågorna och påståendena i den ordinarie enkätmallen."
    },
    "reminder": {
      "addReminderSchedule": "Schemalägg påminnelsemeddelandet"
    },
    "courseList": {
      "courseCode": "Studiemomentets kod: ${ code }",
      "numberOfParticipants": "Totalt antal deltagare på momentet: ${ amount }",
      "noSelectedCourses": "inga valda studiemoment",
      "participantsInfo": "Momentets deltagarförteckning kan ändras tills anmälningarna har bekräftats."
    }
  },
  "surveyReminder": {
    "title": "Påminnelsemeddelande om enkäten",
    "messageSent": "Påminnelsemeddelandet om enkäten har skickats"
  },
  "viewSurveyResponse": {
    "title": "Svar"
  },
  "surveySummary": {
    "title": "Respons",
    "summaryHeading": "Sammandrag",
    "radarChartExplanation": "Sammandrag",
    "radarChartItemDescription": "${ name }: ditt medeltal: ${ userAverage }. Gruppens medeltal: ${ groupAverage }",
    "userAverage": "Ditt medeltal",
    "groupAverage": "Gruppens medeltal",
    "userTotal": "Eget värde",
    "improvementSuggestions": "Tips för utveckling",
    "interpretation": "Tolkning av resultaten",
    "average": "Genomsnitt",
    "standardDeviation": "Standardavvikelse",
    "value1Explanation": "1 - Beskriver din situation illa",
    "value5Explanation": "5 - Beskriver din situation väl",
    "feedbackComputedAt": "Responsen har beräknats",
    "ownResponse": "Egna svar som anknyter till responsen",
    "responseDate": "Besvarad"
  },
  "richText": {
    "bold": "fet stil",
    "italic": "kursiv stil",
    "underline": "understrykning",
    "ul": "lista",
    "ol": "nummerlista"
  },
  "pageNotFound": "Sidan hittas inte",
  "connectionError": "Fel i förbindelsen",
  "errorInResponseTo": "Felmeddelande för inbjudan",
  "header": {
    "siteTitle": "UniHow",
    "logo": {
      "label": "UniHows framsida",
      "description": "UniHow logo"
    },
    "navigation": {
      "surveys": "Enkäter",
      "surveySchemas": "Enkätmallar",
      "adminTools": "Verktyg för administratören"
    },
    "openMenu": "Öppna navigering",
    "closeMenu": "Stäng navigering"
  },
  "footer": {
    "switchboard": "Växel",
    "dps": "Dataskyddsbeskrivning",
    "accessibilityStatement": "Tillgänglighetsutlåtande",
    "externalLink": "Öppnas i en ny flik"
  },
  "editor": {
    "identifier": "Identifikation",
    "identifierError": "Identifikationen är reserverad eller ogiltig. Identifikationen får endast innehålla versaler eller gemener, siffror och _ eller - tecken.",
    "title": "Namn",
    "description": "Beskrivning (inte synlig för respondenterna)",
    "surveySchema": {
      "titlePlaceholder": "Enkätmallens namn",
      "identifierPlaceholder": "Enkätmallens identifikation",
      "descriptionPlaceholder": "Beskrivning av enkätmallen",
      "typePlaceholder": "Välj enkätens typ",
      "introduction": "Standardtext för enkätens inledande text",
      "completion": "Standardtext för enkätens avslutande text",
      "feedbackIntroduction": "Sammandrag av responsen",
      "feedbackIntroductionInfo": "När enkäten har stängts får respondenterna personlig respons som bygger på de dimensioner som definieras i enkätdelarna. Ange sammandragstexten för hela enkäten i fältet nedan. Ändamålet med texten är att förklara syftet med responsvyn och till exempel ge instruktioner om hur man ska läsa responsvyn.",
      "preview": {
        "newSchemaStatusExplanation": "Om du sparar en enkätmall med status Utkast kan mallen ännu inte tas i användning i enkäter. Om du sparar en enkätmall med status Utkast kan mallen ännu inte tas i användning i enkäter. Du kan fortsätta redigera enkätmallen senare.",
        "existingSchemaStatusExplanation": "Om du sparar en enkätmall med status Utkast, uppdateras ändringarna inte i de enkäter till vilken enkätdelen har kopplats. Du kan fortsätta redigera enkätmallen senare. Om du sparar en enkätmall med status Färdig, tas den redigerade enkätmallen i användning i de enkäter till vika mallen kopplats och som ännu inte är schemalagda."
      },
      "edit": {
        "infoTitle": "Redigera enkätmall",
        "inUseExplanation": "<p>Den här enkätmallen används redan i enkäter. Du kan redigera enkätens sammandragstext. Den redigerade texten uppdateras i enkäter och respons i vilka enkätmallen används.</p><p>Om du vill redigera de enkätdelar som kopplats till enkätmallen ska du först skapa en ny version av enkätmallen.</p>",
        "notInUseExplanation": "<p>Den här enkätmallen har ännu inte använts för att starta undersökningar. Du kan fritt redigera enkätmallen.</p><p>Observera att när en enkätmall är i användning i en eller flera enkäter ska du skapa en ny version av enkätmallen innan du kan redigera enkätmallen.</p>"
      },
      "newVersion": {
        "infoTitle": "Ny version av enkätmallen",
        "infoContent": "Du har skapat en ny version av enkätmallen. När du har sparat den nya versionen, ersätter den nya versionen den äldre versionen av den aktuella enkätmallen. Användare som startar enkäter ser endast enkätmallens senaste version. Redigering av enkätmallens nya version påverkar inte uppgifterna i enkäter som redan startat."
      },
      "extraSurveyPart": "Tilläggsfrågor",
      "addExtraSurveyPart": "Välj tilläggsfrågor",
      "invitationEmailTitle": "Meddelande om inbjudan"
    },
    "surveySchemaPart": {
      "titlePlaceholder": "Enkätdelens namn",
      "identifierPlaceholder": "Enkätdelens identifikation",
      "descriptionPlaceholder": "Beskrivning av enkätdelen"
    },
    "surveySchemaPartPreview": {
      "previewDimensionCategory": "Förhandsgranska responskategorin för dimension ${ variableName }",
      "noPreviewDimensions": "Inga förhandsgranskningsbara dimensioner.",
      "unnamedDimension": "Namnlös dimension",
      "unnamedCategory": "Namnlös kategori",
      "noLinkedQuestions": "Inga frågor har kopplats till dimension ${ variableName } och därför kan en förhandsgranskning inte visas.",
      "connectedSchemaNotInUseExplanation": "Enkätdelen är i användning i enkätmallar som ännu inte använts för att starta en enkät. Den redigerade enkätdelen uppdateras i dessa enkätmallar.",
      "connectedSchemaInUseExplanation": "Enkätdelen är i användning i enkätmallar som redan använts för att starta en enkät. Välj de enkätmallar i vilka den redigerade enkätdelen uppdateras. Vid uppdateringen skapas nya versioner av dessa enkätmallar.",
      "variableQuestionsNotSelected": "I enkätdelen finns dimensioner för vilka inga påståenden har valts."
    },
    "surveySchemaParts": {
      "schemaParts": "Enkätdelar",
      "schemaPartsInfo": "Enkätmallen är en helhet där enkäten inleds. Välj vilka enkätdelar enkätmallen består av.",
      "editSchemaParts": "Redigera enkätdelar",
      "chooseSchemaParts": "Välj de enkätdelar som du vill lägga till",
      "loadMoreSchemaParts": "Visa fler delar i enkäten",
      "selectSchemaParts": "Välj delar",
      "updateSchemaPartVersion": "Uppdatera version"
    }
  },
  "surveySchemas": {
    "title": "Enkätmallar",
    "schema": "Enkätmall",
    "schemas": "Enkätmallar",
    "schemaIntroduction": "Enkätmallar helheter som sammanställts från enkätdelar. Enkätmallarna är helheter utifrån vilka enkäterna startas.",
    "createNew": "Skapa ny enkätmall",
    "surveySchemaList": {
      "header": {
        "name": "Namn",
        "code": "Identifikation",
        "version": "Version",
        "status": "Status",
        "lastEdited": "Redigerad"
      },
      "types": {
        "DEGREE_PROGRAM_SURVEY": "HowULearn-enkätmallar",
        "COURSE_SURVEY": "HowUStudy-enkätmallar",
        "HUP": "PhD-enkätmallar",
        "HUT": "HowUTeach-enkätmallar"
      }
    }
  },
  "surveyParts": {
    "identifier": "Identifikation",
    "name": "Enkätdelens namn",
    "required": "Obligatoriskt fält",
    "isRequired": "Frågan är obligatorisk",
    "description": "Beskrivning (inte synlig för respondenterna)",
    "questions": "Frågor",
    "nQuestionsPlural": "frågor",
    "nQuestionsSingular": "fråga",
    "addElement": "Lägg till ett element",
    "responseOption": {
      "empty": "Svarsalternativ saknas"
    },
    "dropdown": {
      "addOption": "Lägg till alternativ",
      "question": {
        "fi": "Kysymys tai väittämä",
        "sv": "Fråga eller påstående",
        "en": "Question or statement"
      },
      "option": {
        "fi": "Vastausvaihtoehto",
        "sv": "Svarsalternativ",
        "en": "Option"
      }
    },
    "radioButtonGroup": {
      "addOption": "Lägg till alternativknapp",
      "question": {
        "fi": "Kysymys tai väittämä",
        "sv": "Fråga eller påstående",
        "en": "Question or statement"
      },
      "option": {
        "fi": "Vastausvaihtoehto",
        "sv": "Svarsalternativ",
        "en": "Option"
      }
    },
    "checkboxGroup": {
      "addOption": "Lägg till kryssruta",
      "question": {
        "fi": "Kysymys tai väittämä",
        "sv": "Fråga eller påstående",
        "en": "Question or statement"
      },
      "option": {
        "fi": "Vastausvaihtoehto",
        "sv": "Svarsalternativ",
        "en": "Option"
      }
    },
    "likert": {
      "questions": "Frågor eller påståenden",
      "addQuestion": "Lägg till fråga eller påstående",
      "addValue": "Lägg till värde",
      "scale": "Skala",
      "scaleStartValue": "Skalans startvärde"
    },
    "itemTitles": {
      "textField": "Öppen fråga",
      "likert": "Likert",
      "customLikert": "Anpassad",
      "heading": "Mellanrubrik",
      "instructionText": "Instruktionstext",
      "dropdown": "Rullgardinsmeny",
      "radioButtonGroup": "Alternativknappar",
      "checkboxGroup": "Kryssrutor"
    },
    "titleMissing": "Ingen rubrik",
    "descriptionMissing": "Ingen beskrivning",
    "validation": {
      "question": {
        "code": {
          "invalid": "Frågans identifikation \"${value}\" är ogiltig",
          "duplicate": "Frågans identifikation \"${value}\" har använts mer än en gång"
        }
      }
    }
  },
  "surveySchemaParts": {
    "schemaParts": "Enkätdelar",
    "schemaPartsIntroduction": "Enkätdelar är färdigt skapade samlingar av frågor som gäller ett visst ämnesområde. De egentliga enkätmallarna sammanställs av enkätdelar.",
    "namePlaceholder": "Enkätdelens namn",
    "identifierPlaceholder": "Enkätdelens identifikation",
    "descriptionPlaceholder": "Beskrivning av enkätdelen",
    "createNew": "Skapa enkätdel",
    "surveyPart": "Enkätdel",
    "partTitle": "Enkätdelens rubrik",
    "selectSurveyType": "Välj enkätens typ",
    "limitedEditingInformationTitle": "Redigera enkätdel",
    "limitedEditingInformation": "Den här enkätdelen används redan i enkäter. Du kan redigera enkätdelens texter för att rätta stavfel. De redigerade texterna uppdateras i de enkätmallar där enkätdelen används och i enkäter som skapats av dessa enkätmallar. Om du vill redigera enkätdelens struktur eller ändra på frågor eller påståenden, skapa en ny version av enkätdelen.",
    "newCopyInformationTitle": "Kopia av enkätdelen",
    "newCopyInformation": "Du gjorde en kopia av enkätdelen. Du kan redigera uppgifterna i enkätdelen samt ta bort, lägga till och redigera frågor, påståenden eller dimensioner. När du sparar en kopia av enkätdelen visas den för användarna som ett separat nytt avsnitt i enkäten. Observera att även om enkätdelens identifikation ändras automatiskt, förblir frågornas och påståendenas identifikationer oförändrade. Vi rekommenderar att du ändrar dem innan du sparar ändringarna.",
    "newVersionInformationTitle": "Ny version av enkätdelen",
    "newVersionInformation": "Du har skapat en ny version av enkätdelen, och du kan fritt redigera den. När du sparar en ny version kan du välja i vilka enkätmallar den nya versionen tas i användning. Redigering av enkätmallens nya version påverkar inte uppgifterna i enkäter som redan startat.",
    "dimensions": {
      "dimensions": "Dimensioner",
      "dimension": "Dimension",
      "name": "Dimensionens namn",
      "nameDescription": "Ge dimensionen ett namn. Namnet visas för användaren i anslutning till responsen",
      "questionsDescription": "Välj de frågor vilkas svar utgör resultatet av denna dimension. Observera att du bara kan välja likert-påståenden som har samma skala.",
      "description": "Beskrivning av dimensionen",
      "descriptionDescription": "Denna gemensamma del visas för alla respondenter",
      "add": "Lägg till dimension",
      "type": {
        "relative": "Dimension - genomsnitt",
        "absolute": "Dimension - norm"
      },
      "relativeFeedback": {
        "belowAverage": "Under genomsnittet",
        "average": "Genomsnitt",
        "overAverage": "Över genomsnittet",
        "feedback": "Responsen i förhållande till genomsnittet",
        "improvementSuggestion": "Tips för utveckling",
        "previewImageAlt": "Responsen i förhållande till genomsnittet, visualisering",
        "categoryError": "Kategorin ${category} identifierades inte som en giltig responskategori"
      },
      "absoluteFeedback": {
        "values": "Normativ skala",
        "valuesDescription": "Definiera skalan för den normativa dimensionen. Det totala poängtalet av användarens svar jämförs med värdena på denna skala. På flikarna nedan kan du definiera de individuella responstexterna som motsvarar skalan.",
        "addValue": "Lägg till värde",
        "feedback": "Ditt värde i förhållande till normen",
        "improvementSuggestion": "Tolkning av resultaten"
      },
      "extraInfo": {
        "heading": "Tilläggsinformation",
        "title": "Tilläggsinformation",
        "description": "Tilläggsinformationen läggs till dimensionen och visas med enkätens respons. Du kan lägga till informationen på tre språk.",
        "edit": "Redigera tilläggsinformationen",
        "editDescription": "Du redigerar tilläggsinformationen för <strong>${ dimensionName }</strong>. Informationen läggs till dimensionen och visas med enkätens respons.",
        "delete": "Töm tilläggsinformationen",
        "deleteConfirmation": "Vill du tömma all tillägsinformation från dimensionen?",
        "titlefi": "Rubrik (FI)",
        "titlesv": "Rubrik (SV)",
        "titleen": "Rubrik (EN)",
        "infofi": "Tilläggsinformation (FI)",
        "infosv": "Tilläggsinformation (SV)",
        "infoen": "Tilläggsinformation (EN)",
        "noExtraInfo": "Ingen tilläggsinformation",
        "requiredDescription": "Fälten är obligatoriska på minst ett språk"
      }
    },
    "schemaPartCount": "enkätdelar",
    "browse": "Bläddra bland enkätdelar",
    "search": {
      "heading": "Sök och filtrera",
      "titleSearch": "Sök med namn eller kod",
      "filter": "Filter",
      "filterOptions": {
        "selfMade": "Skapad av mig"
      }
    },
    "selectedSchemaPartTitle": "Valda delar i enkäten",
    "noSelectedSchemaParts": "Inga valda enkätdelar",
    "noSelectedSchemaPart": "Ingen vald enkätdel",
    "preview": {
      "newSurveyPartStateExplanation": "Om du sparar en enkätdel med status Utkast kan den tas i användning i enkätmallar som också har status Utkast. Om du sparar en enkätdel med status Färdig kan den tas i användning i enkätmallar som också har status Färdig. Du kan fortsätta redigera enkätdelen senare.",
      "existingSurveyPartStateExplanation": "Om du sparar en enkätdel med status Utkast, uppdateras ändringarna inte i de enkätmallar till vilken enkätdelen har kopplats. Du kan fortsätta redigera enkätdelen senare. Om du sparar enkäten med status Färdig, tas den ändrade enkätdelen i användning i de enkätmallar till vilka den kopplats."
    },
    "extraSurveyPart": "Tilläggsfrågor"
  },
  "extraSurveyParts": {
    "title": "Uppsättningar av tilläggsfrågor",
    "createNew": "Skapa en uppsättning tilläggsfrågor",
    "loadMore": "Visa fler tilläggsfrågor",
    "extraPartsIntroduction": "Uppsättningar av tilläggsfrågor är en på förhand definierad uppsättning frågor som kan fogas i slutet av en enkät som ska startas. Tilläggsfrågor kan användas för att komplettera en enkätmall separat för en enskild enkät.",
    "surveyPart": "Uppsättning av tilläggsfrågor",
    "namePlaceholder": "Namnet på uppsättningen av tilläggsfrågor",
    "identifierPlaceholder": "Identifikation för uppsättningen av tilläggsfrågor",
    "descriptionPlaceholder": "Beskrivning av uppsättningen av tilläggsfrågor",
    "partTitle": "Rubrik för uppsättningen av tilläggsfrågor",
    "newCopyInformationTitle": "Kopia av uppsättning av tilläggsfrågor",
    "newCopyInformation": "Du har gjort en kopia av uppsättningen av tilläggsfrågor. Du kan fritt redigera tilläggsfrågorna i kopian utan att de ursprungliga tilläggsfrågorna eller enkäterna som använder dem påverkas. Observera att även om enkätdelens identifikation ändras automatiskt, förblir frågornas och påståendenas identifikationer oförändrade. Vi rekommenderar att du ändrar dem innan du sparar ändringarna.",
    "limitedEditingInformation": "Dessa tilläggsfrågor är redan i användning i en enkät. Du kan redigera enkätdelens texter för att rätta stavfel. De redigerade texterna uppdateras också i pågående enkäter. Om du vill redigera enkätdelens struktur eller ändra på frågor eller påståenden, skapa en ny uppsättning av tilläggsfrågor.",
    "limitedEditingInformationTitle": "Redigera tilläggsfrågor",
    "selectedSchemaPartTitle": "Vald uppsättning av tilläggsfrågo",
    "noSelectedSchemaPart": "Ingen vald uppsättning av tilläggsfrågor",
    "preview": {
      "newSurveyPartStateExplanation": "Om du sparar en tilläggsfrågedel med status Publicerad, kan den tas i användning i enkäter. Du kan fortsätta redigera tilläggsfrågedelen senare.",
      "existingSurveyPartStateExplanation": "Om du sparar en tilläggsfrågedel med status Publicerad, kan den tas i användning i enkäter. Du kan fortsätta redigera tilläggsfrågedelen senare."
    },
    "browse": "Bläddra bland uppsättningar av tilläggsfrågor",
    "searchResult": "Uppsättningar av tilläggsfrågor som uppfyller sökkriterierna",
    "extraPartCount": "tilläggsfrågor",
    "sensitiveInfoNotification": "Vänligen be inte om hälsoinformation eller annan känslig information"
  },
  "manageSurveys": {
    "openSurveys": "Öppna enkäter",
    "hulSurveys": "HowULearn-enkäter",
    "husSurveys": "HowUStudy-enkäter",
    "hupSurveys": "PhD-enkäter",
    "hutSurveys": "HowUTeach-enkäter",
    "openStudyProgramSurveys": "Öppna HowULearn-enkäter",
    "openCourseSurveys": "Öppna HowUStudy-enkäter",
    "closedSurveys": "Stängda enkäter",
    "closedStudyProgramSurveys": "Stängda HowULearn-enkäter",
    "closedCourseSurveys": "Stängda HowUStudy-enkäter",
    "confirmCloseSurvey": "Bekräfta att enkäten stängs",
    "nSurveys": "enkäter",
    "nParticipants": "${ count } deltagare",
    "nSurveySchemas": "enkätmallar",
    "showArchived": "Visa arkiverade",
    "state": "Status",
    "responseTime": "Svarstid",
    "numberOfResponses": "Svar",
    "quickSteps": "Snabbfunktioner",
    "addParticipant": "Lägg till en deltagare",
    "removeParticipant": "Ta bort en deltagare",
    "removeParticipantConfirm": "Ta bort deltagare?",
    "removeAnswers": "Ta bort svaren",
    "removeAnswersConfirm": "Ta bort deltagarens svar?",
    "participants": "Deltagare",
    "closeSurvey": "Stäng enkäten",
    "editScheduling": "Redigera schemaläggning",
    "notEnoughResponses": "Inte tillräckligt med svar",
    "closeSurveyAreYouSure": "Stäng enkäten? Om du vill, kan du öppna en stängd enkät på nytt från funktionerna för stängd enkät.",
    "browseSurveys": "Bläddra bland enkäter",
    "startSurvey": "Starta enkät",
    "reopen": {
      "title": "Öppna enkät",
      "description": "Ange sluttiden för enkäten som öppnas på nytt samt tidpunkten när responsen öppnas. Efter att du öppnat enkäten kan du lägga till eller ta bort deltagare eller skicka en påminnelse om enkäten på normalt sätt från enkätens funktioner.",
      "doNotSendStartNotification": "Skicka inte inbjudningsmeddelande",
      "newParticipants": {
        "title": "Nya mottagare",
        "description": "Du kan lägga till nya enkätdeltagare som får en inbjudan till enkäten. Tidigare inbjudna deltagare som ännu inte har svarat på enkäten kan svara på enkäten som öppnats på nytt."
      }
    },
    "scheduling": {
      "title": "Redigera enkätens schemaläggning",
      "reminderMessageInfo": "Informera de studerande som deltar i enkäten om enkätens nya stängningstid.",
      "saveAndSendMessage": "Spara och skicka",
      "surveyRescheduledAndReminderSent": "Enkätens nya stängningstid ställdes in på ${ endDate } och ett meddelande om detta har skickats till alla deltagare."
    },
    "search": {
      "title": "sökning",
      "hide": "Dölj sökning",
      "titleSearchPlaceholder": "Sök på enkätens namn",
      "degreeProgramSearchPlaceholder": "Målgrupp",
      "surveyStartedAfterPlaceholder": "Startdatum efter",
      "surveyStartedBeforePlaceholder": "Startdatum före",
      "stateSearchPlaceholder": "Enkätens status",
      "surveyNameLabel": "Enkätens namn"
    }
  },
  "surveyStatistics": {
    "responseCount": "Svar",
    "openQuestionCount": "Öppna frågor i denna enkät:",
    "researchConsentGivenCount": "Forskningstillstånd",
    "reminderSentAt": "Påminnelsemeddelande skickades",
    "feedbackViewCount": "Responsen har lästs av",
    "feedbackViewCountDisclaimer": "Insamlingen av uppföljningsdata inleddes 9.12.2019",
    "smallest": "Minst",
    "largest": "Störst",
    "noStatsUntilClosed": "Enkätens resultat kan visas först när enkäten stängts.",
    "notEnoughResponses": "Enkätens resultat kan inte visas eftersom det inte finns tillräckligt med svar.",
    "computingStatistics": "Enkätens resultat kan inte visa eftersom beräkningen av dem fortfarande pågår.",
    "dimensions": "Dimensioner",
    "otherAnswers": "Fördelningen av övriga svar",
    "answerDistributions": "Svarsfördelningar",
    "extraQuestions": "Tilläggsfrågor",
    "responseDistribution": "Som hjälp vid tolkningen av resultaten",
    "responsesToOpenQuestions": "Svaren på öppna frågor",
    "dimensionStatements": "Påståendena i dimensionen",
    "statisticsComputedAt": "Statistiken har beräknats",
    "reminderTimes": "Schemalagda påminnelsemeddelanden",
    "viewOpenQuestionResponseReport": "Visa svaren på öppna frågor"
  },
  "feedbackBox": {
    "feedback": "Kontakta oss",
    "placeholder": "Kontakta oss eller ge respons på tjänsten...",
    "submit": "Sänd",
    "thanks": "Tack"
  },
  "surveyResponseTimeEnd": {
    "warning": "Observera att enkäten stänger kl. ${endTime}. Efter det tas svaret inte längre emot.",
    "timeout": "Undersökningen hann stängas, dina svar kunde inte sparas."
  },
  "textInput": {
    "maxLength": "Det maximala antalet tecken i fältet är "
  },
  "status": {
    "DRAFT": "Utkast",
    "PUBLISHED": "Färdig",
    "IN_USE": "Används",
    "NOTUSED": "Används inte",
    "ARCHIVED": "Arkiverad"
  },
  "actions": {
    "archive": "Arkivera",
    "confirmArchiveSurveySchema": "Arkivera enkätmallen? En arkiverad enkätmall kan inte längre användas för att skapa nya enkäter.",
    "viewVersionHistory": "Bläddra bland versionerna",
    "createNewCopy": "Skapa en ny kopia",
    "createNewVersion": "Skapa en ny version",
    "edit": "Redigera"
  },
  "environment": {
    "info": {
      "demo": "Obs! Detta är en demonstrationsmiljö och uppgifterna är inte riktiga. För riktiga uppgifter gå till"
    }
  },
  "permissionManagement": {
    "title": "Administrera behörigheter",
    "basicInfo": "Grundläggande information",
    "description": "Administrera behörigheter",
    "user": "Användare",
    "saveSuccess": "Ändringarna sparades",
    "role": "Roll",
    "generalRoles": "Allmänna roller",
    "surveyRoles": "Enkätroller",
    "noRole": "Ingen roll",
    "anyRole": "Valfri roll",
    "all": "Alla",
    "searchUsers": "Sök användare",
    "roleFilters": "Rollgräns",
    "searchFilter": "Avgränsning av sökning",
    "clearFilters": "Ta bort avgränsningar"
  },
  "activityLog": {
    "activityLog": "Aktivitetslogg",
    "action": "Funktion",
    "exportReason": "Export reason (sv)",
    "EXPORT_DATA": "Export",
    "EXPORT_SENSITIVE_DATA": "Forskningsexport"
  },
  "MESSAGES": {
    "defaultSurveyInvitationTitle": {
      "DEGREE_PROGRAM_SURVEY": "Inbjudan till HowULearn-enkäten",
      "COURSE_SURVEY": "Inbjudan till HowUStudy-enkäten",
      "HUP": "Inbjudan till PhD-enkäten",
      "HUT": "Inbjudan till HowUTeach-enkäten"
    },
    "defaultSurveyInvitationContent": {
      "DEGREE_PROGRAM_SURVEY": "Hej!\n\nVälkommen att svara på HowULearn-enkäten om lärande och undervisning. Med HowULearn-enkäten stöds studerandenas lärande och studier samt utvecklingen av undervisningens kvalitet.\n\nEfter att enkäten stängts får du personlig respons som utgår från dina enkätsvar. Responsen innehåller tips som utarbetats av forskare och sakkunniga inom högskolepedagogik till stöd för dina studier. Dessutom kan du jämföra dina egna svar med hur andra studerande som deltog i enkäten svarade på olika delområden i enkäten.\n\nTjänsten Unihow skapar också ett sammandrag av enkätsvaren, där svaren behandlas på gruppnivå. Med hjälp av enkätens respons kan utbildningsanordnaren, lärarna och utbildningens ledning utveckla undervisningen så att den ännu bättre stöder studerandenas lärande och undervisningens kvalitet.\n\nDu kan svara på enkäten genom att logga in med ditt användarnamn för din högskola. När enkäten har stängts kan du bekanta dig med responsen i tjänsten UniHow.\n\nGå till enkäten: [QUESTIONNAIRE_LINK_TAG]\n\nSvara på enkäten senast [QUESTIONNAIRE_END_DATE_TAG].\n\nTack på förhand för ditt deltagande!\n\nDet här meddelandet har skickats automatiskt från tjänsten UniHow. Du kan inte svara på meddelandet.\n\nUniHow är ett finländskt stödverktyg för att utveckla lärandet och undervisningen, som utvecklas i samarbete mellan Funidata Oy och Helsingfors universitet.\n\nMer information om Funidata och UniHow hittar du på webbplatsen: https://funidata.fi/palvelut/unihow.\n",
      "COURSE_SURVEY": "Hej!\n\nVälkommen att svara på HowULearn-enkäten om lärande och undervisning. Med HowULearn-enkäten stöds studerandenas lärande och studier samt utvecklingen av undervisningens kvalitet.\n\nEfter att enkäten stängts får du personlig respons som utgår från dina enkätsvar. Responsen innehåller tips som utarbetats av forskare och sakkunniga inom högskolepedagogik till stöd för dina studier. Dessutom kan du jämföra dina egna svar med hur andra studerande som deltog i enkäten svarade på olika delområden i enkäten.\n\nTjänsten Unihow skapar också ett sammandrag av enkätsvaren, där svaren behandlas på gruppnivå. Med hjälp av enkätens respons kan utbildningsanordnaren, lärarna och utbildningens ledning utveckla undervisningen så att den ännu bättre stöder studerandenas lärande och undervisningens kvalitet.\n\nDu kan svara på enkäten genom att logga in med ditt användarnamn för din högskola. När enkäten har stängts kan du bekanta dig med responsen i tjänsten UniHow.\n\nGå till enkäten: [QUESTIONNAIRE_LINK_TAG]\n\nSvara på enkäten senast [QUESTIONNAIRE_END_DATE_TAG].\n\nTack på förhand för ditt deltagande!\n\nDet här meddelandet har skickats automatiskt från tjänsten UniHow. Du kan inte svara på meddelandet.\n\nUniHow är ett finländskt stödverktyg för att utveckla lärandet och undervisningen, som utvecklas i samarbete mellan Funidata Oy och Helsingfors universitet.\n\nMer information om Funidata och UniHow hittar du på webbplatsen: https://funidata.fi/palvelut/unihow.\n",
      "HUT": "Hej!\n\nVälkommen att svara på HowUTeach-enkäten.\n"
    },
    "defaultSurveyEndedTitle": {
      "DEGREE_PROGRAM_SURVEY": "Din HowULearn-respons är nu tillgänglig",
      "COURSE_SURVEY": "",
      "HUP": "Din PhD-respons är nu tillgänglig",
      "HUT": "Din HowUTeach-respons är nu tillgänglig"
    },
    "defaultSurveyEndedContent": {
      "DEGREE_PROGRAM_SURVEY": "Hej!\n\nDu har svarat på HowULearn-enkäten om lärande och studier. Bekanta dig med responsen i tjänsten UniHow på adressen [QUESTIONNAIRE_FEEDBACK_LINK_TAG].\n\nResponsen är baserad på de svar du gett. Responsen innehåller tips från högskolepedagogisk forskning till stöd för studierna. Dessutom kan du jämföra dina egna svar med hur andra studerande svarade på frågorna i enkätens olika delområden.\n\nDetta är ett automatiskt meddelande från tjänsten UniHow. Du kan inte svara på meddelandet. UniHow är ett finländskt verktyg för utveckling av lärande och undervisning. Funidata Oy och Helsingfors universitet utvecklar tjänsten i samarbete. Mer information om Funidata och UniHow hittar du på webbplatsen: https://funidata.fi/palvelut/unihow.\n",
      "COURSE_SURVEY": "",
      "HUP": "Hej!\n\nDu har besvarat PhD-enkäten, i vilken vi utredde dina upplevelser kring doktorandprocessen. Läs responsen i tjänsten UniHow på [QUESTIONNAIRE_FEEDBACK_LINK_TAG].\n\nResponsen baseras på svaren du angav i enkäten. Responsen innehåller tips baserade på doktorsutbildningens forskning, till stöd för ditt avhandlingsarbete. Dessutom kan du jämföra dina svar med hur andra doktorandrespondenter besvarade enkätens olika delområden.\n\nDetta är ett automatiskt meddelande från tjänsten UniHow. Du kan inte svara på meddelandet. UniHow är ett finländskt verktyg för utveckling av lärande och undervisning. Funidata Oy och Helsingfors universitet utvecklar tjänsten i samarbete. Mer information om Funidata och UniHow hittar du på webbplatsen: https://funidata.fi/palvelut/unihow.\n",
      "HUT": "Hej!\n\nDu har svarat på HowUTeach-enkäten om din undervisning. Bekanta dig med responsen i tjänsten UniHow på adressen [QUESTIONNAIRE_FEEDBACK_LINK_TAG].\n\nResponsen är baserad på de svar du gett. Responsen innehåller tips från högskolepedagogisk forskning till stöd för undervisning. Dessutom kan du jämföra dina egna svar med hur andra studerande svarade på frågorna i enkätens olika delområden.\n\nDetta är ett automatiskt meddelande från tjänsten UniHow. Du kan inte svara på meddelandet. UniHow är ett finländskt verktyg för utveckling av lärande och undervisning. Funidata Oy och Helsingfors universitet utvecklar tjänsten i samarbete. Mer information om Funidata och UniHow hittar du på webbplatsen: https://funidata.fi/palvelut/unihow.\n"
    },
    "defaultSurveyReminderTitle": {
      "DEGREE_PROGRAM_SURVEY": "Inbjudan till HowULearn-enkäten",
      "COURSE_SURVEY": "",
      "HUP": "Inbjudan till PhD-enkäten",
      "HUT": "Inbjudan till HowUTeach-enkäten"
    },
    "defaultSurveyReminderContent": {
      "DEGREE_PROGRAM_SURVEY": "Hej!\n\nDu har ännu inte svarat på HowULearn-enkäten om lärande och undervisning.\n\nHowULearn-enkäterna stöder studerandena i lärandet och studierma samt utvecklingen av undervisningens kvalitet. Efter att enkäten stängts får du personlig respons som baserar sig på svaren du gav.\n\nDu kan svara på enkäten genom att logga in I tjänsten med användarnamnet för din högskola.\n\nGå till enkäten: [QUESTIONNAIRE_LINK_TAG].\n\nSvara på enkäten senast [QUESTIONNAIRE_END_DATE_TAG].\n\nTack på förhand för ditt deltagande!\n\nDetta är ett automatiskt meddelande från tjänsten UniHow. Du kan inte svara på meddelandet.\n\nUniHow är ett finländskt hjälpmedel för utveckling av lärande och undervisning, som Funidata Oy och Helsingfors universitet utvecklar i samarbete. Mer information om Funidata och UniHow hittar du på webbplatsen: https://funidata.fi/palvelut/unihow.\n",
      "COURSE_SURVEY": "",
      "HUP": "Hej!\n\nDu har ännu inte besvarat PhD-enkäten gällande doktoranders upplevelser.\n\nSyftet med PhD-enkäten är att hjälpa dig att strukturera dina upplevelser kring din doktorsavhandling och identifiera faktorer som påverkar den. Enkätens respons utnyttjas för att utveckla doktorsutbildningen. När enkäten har avslutats får du personlig respons som baseras på svaren du gav.\n\nDu kan svara på enkäten genom att logga in I tjänsten med användarnamnet för din högskola.\n\nGå till enkäten: [QUESTIONNAIRE_LINK_TAG].\n\nSvara på enkäten senast [QUESTIONNAIRE_END_DATE_TAG].\n\nTack på förhand för ditt deltagande!\n\nDetta är ett automatiskt meddelande från tjänsten UniHow. Du kan inte svara på meddelandet.\n\nUniHow är ett finländskt hjälpmedel för utveckling av lärande och undervisning, som Funidata Oy och Helsingfors universitet utvecklar i samarbete. Mer information om Funidata och UniHow hittar du på webbplatsen: https://funidata.fi/palvelut/unihow.\n",
      "HUT": "Hej!\n\nDu har ännu inte svarat på HowUTeach-enkäten om undervisning.\n\nEfter att enkäten stängts får du personlig respons som baserar sig på svaren du gav.\n\nDu kan svara på enkäten genom att logga in I tjänsten med användarnamnet för din högskola.\n\nGå till enkäten: [QUESTIONNAIRE_LINK_TAG].\n\nSvara på enkäten senast [QUESTIONNAIRE_END_DATE_TAG].\n\nTack på förhand för ditt deltagande!\n\nDetta är ett automatiskt meddelande från tjänsten UniHow. Du kan inte svara på meddelandet.\n\nUniHow är ett finländskt hjälpmedel för utveckling av lärande och undervisning, som Funidata Oy och Helsingfors universitet utvecklar i samarbete. Mer information om Funidata och UniHow hittar du på webbplatsen: https://funidata.fi/palvelut/unihow.\n"
    },
    "defaultSurveyIntroduction": {
      "DEGREE_PROGRAM_SURVEY": "<p>Välkommen att svara på HowULearn-enkäten!</p><p>Syftet är att med HowULearn-enkäten få information om studenternas studier och undervisning. Fundera på dina egna studier, lärande och nuvarande studiesituation. Frågorna och påståendena i HowULearn baserar sig på forskning och högskoleinlärning och -undervisning. Det finns inga bra eller dåliga svar på frågorna. Svara på varje fråga enligt din bästa förmåga och så ärligt som du kan.</p><p>När enkäten avslutats får du personlig respons som baserar sig på svaren du gav. Responsen innehåller tips från forskare och sakkunniga inom högskolepedagogik och studiepsykologer som stöd för studierna.</p>",
      "COURSE_SURVEY": "",
      "HUP": "<p>Välkommen att besvara PhD-enkäten!</p><p>Med hjälp av PhD-enkäten får vi information om doktoranders upplevelser av avhandlingsarbetet. Frågorna och påståendena i enkäten är utarbetade utgående från forskning om doktorandutbildningen. Det finns inga bra eller dåliga svar på frågorna. Det tar cirka 15-20 minuter att besvara enkäten. När enkätens svarstid har löpt ut, ger systemet dig respons på dina svar. Responsen innehåller information och tips som kan hjälpa dig att strukturera dina upplevelser kring din doktorsavhandling och identifiera faktorer som påverkar den. Responsen baseras på forskning om doktorsutbildningen. Responsen är endast synlig för dig. Den insamlade informationen utnyttjas endast statistiskt på gruppnivå, vilket innebär att enskilda respondenters svar inte rapporteras.</p>",
      "HUT": "<p>Välkommen att svara på en HowUTeach-enkät!</p>"
    },
    "defaultSurveyConclusion": {
      "DEGREE_PROGRAM_SURVEY": "<p>Tack för ditt deltagande!</p><p>När enkäten avslutats får du bekanta dig med responsen, som baserar sig på svaren du gav. Responsen innehåller tips från forskare och sakkunniga inom högskolepedagogik och studiepsykologer som stöd för studierna. Dessutom kan du jämföra dina egna svar med de andra deltagarnas svar på de olika delområdena i enkäten.</p><p>Baserat på svaren bildar tjänsten också ett sammandrag, som behandlar svaren på gruppnivå. Utifrån responsen kan utbildningsanordnaren, dina lärare och utbildningens ledning utveckla undervisningen så att den ännu bättre stöder studerandenas studier och lärande.</p><p>Du får en avisering per e-post när din respons finns att läsa i tjänsten UniHow.</p>",
      "COURSE_SURVEY": "",
      "HUP": "<p>Tack för ditt deltagande!</p><p>När enkäten har avslutats kan du läsa responsen som baseras på svaren du gav. Responsen innehåller tips utarbetade av forskare och experter inom doktorsutbildningen, som kan fungera som stöd för ditt avhandlingsarbete. Nu kan du jämföra dina svar med hur andra doktorander besvarade enkätens olika delområden.</p><p>Tjänsten skapar dessutom en sammanställning av enkätsvaren, i vilken svaren behandlas på gruppnivå. Utgående från enkätresponsen har vi möjlighet att utveckla doktorsutbildningen så att den bättre stöder doktorandernas studier och välbefinnande.</p><p>Ett e-postmeddelande skickas till dig när din respons finns att läsa i tjänsten UniHow.</p>",
      "HUT": "<p>Tack för ditt deltagande!</p>Du får en avisering per e-post när din respons finns att läsa i tjänsten UniHow.</p>"
    },
    "likert5DefaultOptions": {
      "1": "Helt av annan åsikt",
      "2": "Av annan åsikt",
      "3": "Varken av samma eller annan åsikt",
      "4": "Av samma åsikt",
      "5": "Helt av samma åsikt"
    },
    "likert6DefaultOptions": {
      "1": "Helt av annan åsikt",
      "2": "Av annan åsikt",
      "3": "Delvis av annan åsikt",
      "4": "Delvis av samma åsikt",
      "5": "Av samma åsikt",
      "6": "Helt av samma åsikt"
    },
    "likert7DefaultOptions": {
      "1": "Helt av annan åsikt",
      "2": "Av annan åsikt",
      "3": "Delvis av annan åsikt",
      "4": "Varken av samma eller annan åsikt",
      "5": "Delvis av samma åsikt",
      "6": "Av samma åsikt",
      "7": "Helt av samma åsikt"
    },
    "likertDefaultOptions": {
      "agree": "Helt av samma åsikt",
      "neutral": "Varken av samma eller annan åsikt",
      "disagree": "Helt av annan åsikt"
    },
    "defaultRelativeFeedback": "Ditt resultat var {{USER_RESULT}} och hela gruppens medeltal var  {{GROUP_RESULT}}.",
    "defaultFeedbackIntroductionContent": {
      "DEGREE_PROGRAM_SURVEY": "Du har svarat på en HowULearn-enkät där man bland annat frågade om dina preferenser och vanor i samband med studier och lärande. Enkäten ger information om ditt sätt att studera och dina upplevelser av inlärningsmiljön i förhållande till hela gruppens svar.\n\nAv resultaten ser du först hur du har svarat på undersökningens olika dimensioner. Du får respons enligt dina svar om hur svaren återspeglar dimensionerna. Dimensionerna består av flera olika påståenden, inte enstaka påståenden. Kom ihåg att svaren grundas på din egen tolkning av ditt lärande. Det handlar inte om permanenta egenskaper. Du kan använda responsen för att utveckla din studieförmåga.\n",
      "COURSE_SURVEY": "Du har svarat på en HowULearn-enkät där man bland annat frågade om dina preferenser och vanor i samband med studier och lärande. Enkäten ger information om ditt sätt att studera och dina upplevelser av inlärningsmiljön i förhållande till hela gruppens svar.\n\nAv resultaten ser du först hur du har svarat på undersökningens olika dimensioner. Du får respons enligt dina svar om hur svaren återspeglar dimensionerna. Dimensionerna består av flera olika påståenden, inte enstaka påståenden. Kom ihåg att svaren grundas på din egen tolkning av ditt lärande. Det handlar inte om permanenta egenskaper. Du kan använda responsen för att utveckla din studieförmåga.\n",
      "HUP": "Du har besvarat en enkät, i vilken vi utredde dina upplevelser kring doktorandprocessen. Enkäten kan hjälpa dig att förstå dina upplevelser också i förhållande till andra doktoranders upplevelser.\n\nI responsen ser du först vad du har svarat på enkätens olika delområden i förhållande till andra doktorander. Denna respons baseras på påståendena med anknytning till varje tema, inte enskilda påståenden. Efter responsen får du information och tips gällande följande teman: 1) motivation, 2) handledarens stöd, 3) forskarsamhällets stöd, 4) avhandlingsentusiasm och 5) utbrändhet inom doktorandutbildningen. Dina upplevelser av doktorsstudierna kan variera i olika skeden av processen. Du kan utnyttja responsen som stöd på din väg genom doktorandutbildningen.\n",
      "HUT": "Du har svarat på en HowUTeach-enkät."
    },
    "researchAgreement": {
      "petition": {
        "DEGREE_PROGRAM_SURVEY": "<p>Vi ber om tillstånd för att använda dina svar i forskning, som behandlar studerandenas lärande och deras erfarenheter av inlärningsmiljön. I samband med forskningsanvändningen kan uppgifter om studieprestationer och studierätt samt UniHow-systemets logguppgifter (definieras närmare i dataskyddsmeddelandet) kopplas till svaren du gav i denna enkät. Enskilda studerandens uppgifter rapporteras inte alls. Materialet behandlas, analyseras och lagras konfidentiellt. Responsen rapporteras i enlighet med god vetenskaplig praxis.</p><p>Det är helt frivilligt att ge forskningstillstånd och tillståndet påverkar inte responsen du får. Forskningstillståndet kan också återkallas.</p>",
        "COURSE_SURVEY": "<p>Vi ber om tillstånd för att använda dina svar i forskning, som behandlar studerandenas lärande och deras erfarenheter av inlärningsmiljön. I samband med forskningsanvändningen kan uppgifter om studieprestationer och studierätt samt UniHow-systemets logguppgifter (definieras närmare i dataskyddsmeddelandet) kopplas till svaren du gav i denna enkät. Enskilda studerandens uppgifter rapporteras inte alls. Materialet behandlas, analyseras och lagras konfidentiellt. Responsen rapporteras i enlighet med god vetenskaplig praxis.</p><p>Det är helt frivilligt att ge forskningstillstånd och tillståndet påverkar inte responsen du får. Forskningstillståndet kan också återkallas.</p>",
        "HUP": "<p>Vi ber om ditt samtycke till att använda dina svar i forskningen kring doktorsutbildningen. Om svaren används för forskning kan uppgifter om studieprestationer och studierätt samt UniHow-systemets logguppgifter (definieras närmare i dataskyddsmeddelandet) kopplas till svaren du gav i denna enkät. Enskilda studerandens uppgifter rapporteras inte alls. Materialet behandlas, analyseras och lagras konfidentiellt. Responsen rapporteras i enlighet med god vetenskaplig praxis.</p><p>Det är helt frivilligt att ge forskningstillstånd och tillståndet påverkar inte responsen du får. Forskningstillståndet kan också återkallas.</p>",
        "HUT": "<p>Vi ber om tillstånd för att använda dina svar i forskning.</p>Materialet behandlas, analyseras och lagras konfidentiellt. Responsen rapporteras i enlighet med god vetenskaplig praxis.</p><p>Det är helt frivilligt att ge forskningstillstånd och tillståndet påverkar inte responsen du får. Forskningstillståndet kan också återkallas.</p>"
      },
      "furtherInformation": "Mer information om forskningsanvändning och om att återkalla forskningstillstånd:",
      "privacyNotice": "Dataskyddsmeddelande för forskningsanvändning:"
    }
  },
  "surveysLandingPage": {
    "title": "Enkäter",
    "hulSurvey": "HowULearn-enkät",
    "hulSurveyDescription": "Påståendena i HowULearn-enkäten gäller bland annat studenternas engagemang, välbefinnande, studieupplevelser och åsikter om inlärningsmiljön. Syftet med HowULearn-enkäten är att ta reda på den studerandes erfarenheter av en studiehelhet och fokuserar inte på specifika kurser eller studieserier.",
    "husSurvey": "HowUStudy-enkät",
    "husSurveyDescription": "HowUStudy-enkäter används för att samla in respons på en enskild kurs eller studiehelhet i stället för den traditionella kursresponsblanketten. HowUStudy-frågor är mer förenklade till sin natur än HowULearn-frågor.",
    "hupSurvey": "PhD-enkät",
    "hupSurveyDescription": "Påståendena i PhD-enkäten anknyter till doktoranders upplevelser kring doktorandprocessen. Med denna enkät utreds till exempel doktoranders upplevelser av motivation, välbefinnande i doktorsutbildningen och stöd från handledare och forskarsamhället.",
    "hutSurvey": "HowUTeach-enkät",
    "hutSurveyDescription": "HowUTeach-enkäterna har utvecklats som ett självutvärderingsverktyg för högskolelärare. Ämnesområdena i HowUTeach-enkäten handlar till exempel om undervisningsmetoder och undervisningens mål.",
    "buttons": {
      "start": "Starta enkät",
      "browse": "Bläddra bland enkäter"
    }
  },
  "selectSchemaDialog": {
    "title": "Starta ny ${ schemaType }",
    "selectSchema": "Välj enkätmall"
  },
  "selectSchemaTypeDialog": {
    "title": "Välj enkättyp",
    "label": "Välj den enkättyp som du vill skapa enkätmallen för"
  },
  "selectSurveyPartTypeDialog": {
    "surveyPartLabel": "Select the survey type for which you want to create a survey element",
    "extraPartLabel": "Select the survey type for which you want to create an additional question"
  },
  "adminTools": {
    "title": "Verktyg för administratören",
    "permissions": "Användarbehörigheter",
    "activityLog": "Aktivitetslogg"
  },
  "accessibilityStatement": {
    "mainTitle": "Tillgänglighetsredogörelse",
    "generalInfo": "Denna tillgänglighetsredogörelse gäller webbtjänsten UniHow och har uppdaterats 18.3.2026. Webbtjänster berörs av lagen om tillhandahållande av digitala tjänster, i vilken det förutsätts att offentliga webbtjänster ska vara tillgängliga. Webbtjänstens tillgänglighet har utvärderats av en extern expertorganisation.",
    "accessibilityStatementHeading": "Tillgänglighetsstatus för den digitala tjänsten",
    "accessibilityStatementContent": "Denna webbtjänst uppfyller tillgänglighetskraven delvis.",
    "nonAccessibleContentHeading": "Icke-tillgängligt innehåll",
    "nonAccessibilityGeneralInfo": "Webbtjänsten överensstämmer ännu inte med tillgänglighetskraven till alla delar. Nedanstående innehåll och/eller funktioner överensstämmer ännu inte med kraven:",
    "listOfAccessibilityErrors": [
      {
        "heading": "Allmänna, gäller hela webbtjänsten ",
        "descriptionList": [
          "Webbtjänsten informerar inte användaren om tidsgränsen för automatisk utloggning. (WCAG 2.2.1)."
        ]
      },
      {
        "heading": "Ingångssida",
        "descriptionList": [
          "Stängningsknappen för modalen Kontakta oss saknar textalternativ. (WCAG 4.1.2).",
          "Meddelandefältet Kontakta oss saknar en tillgänglig etikett. (WCAG 1.1.1, 3.3.2, 4.1.2).",
          "Det finns inte tillräckligt mycket kontrast i tackmeddelandet i komponenten Kontakta oss. (WCAG 1.4.3)."
        ]
      },
      {
        "heading": "Respons",
        "descriptionList": [
          "Skärmläsaren läser inte texten ”Gruppens medeltal” eftersom det finns ett fel i HTML-koden. (WCAG 1.1.1, 1.3.1).",
          "Skärmläsaren läser inte upp procenttalen i grafen. (WCAG 1.1.1)."
        ]
      }
    ],
    "contactInformationHeading": "Tillgänglighetsrespons och kontaktuppgifter",
    "contactInformationContent": "Vi välkomnar förslag, iakttagelser, frågor och förbättringsförslag gällande denna webbtjänst och dess tillgänglighet, via e-post till adressen",
    "governingAgencyHeading": "Tillsynsmyndigheten",
    "governingAgencyContent": "Om du upptäcker tillgänglighetsproblem i webbtjänsten, lämna först respons till oss, dvs. till webbplatsadministratören. Svar kan dröja upp till 14 dagar. Om du inte är nöjd med det svar du har fått eller inte får något svar alls inom två veckor kan du anmäla det till tillsynsmyndigheten.",
    "governingAgencyContactHeading": "Tillsynsmyndighetens kontaktinformation",
    "governingAgencyName": "Transport- och kommunikationsverket Traficom\nTillgänglighetstillsyn",
    "governingAgencyUrl": "www.saavutettavuusvaatimukset.fi/sv",
    "governingAgencyEmail": "tillganglighet@traficom.fi",
    "governingAgencyPhoneDescription": "telefonnummer växeln",
    "governingAgencyPhoneNumber": "029 534 5000"
  },
  "errorSummary": {
    "heading": "Komplettera eller korrigera följande uppgifter"
  }
}
